import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {HardwareInfoDialogComponent} from "../dialogs/hardware-info-dialog/hardware-info-dialog.component";
import {humanReadableBytes} from "../../../../../lib/utils/function-utils";
import {MatSort, MatSortable} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {
  DesactivationConfigDialogComponent
} from "../dialogs/desactivation-config-dialog/desactivation-config-dialog.component";
import {MessageTypeEnum} from "../../database-group/database-group.component";
import {DesktopService} from "../../../../../lib/services/desktop.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Config, DesktopInfos} from "../../../../../lib/models/desktop.model";

type DesktopConfig = Partial<Config> & {
  isMauriceInitialized?: boolean;
};

@Component({
  selector: 'ms-database-group-info-hardware',
  templateUrl: './database-group-info-hardware.component.html',
  styleUrls: ['./database-group-info-hardware.component.scss'],
  standalone: false
})
export class DatabaseGroupInfoHardwareComponent implements OnInit{

  @Input() desktopInfos: DesktopInfos | null = null;
  @ViewChild(MatSort, {static: true}) sort!: MatSort;

  public dataSource = new MatTableDataSource<DesktopConfig>();
  public hasDesktopApiContent = false;
  public readonly isMedispringHost: boolean = /(^|\.)medispring\.be$/i.test(window.location.hostname);

  public displayedColumns: string[] = [
    'lastUpdate',
    'configId',
    'currentVersion',
    'couchDBVersion',
    'electronVersion',
    'mainUrl',
    'ramQty',
    'diskSize',
    'diskSapceFree',
    'diskPath',
    'actions'
  ];
  public isLoading = false;

  constructor(
    private dialog: MatDialog,
    private desktopService: DesktopService,
    private snackBar: MatSnackBar,
  ) {
  }

  public ngOnInit() {
    this.initialize();
  }

  private initialize(){
    this.isLoading = true;
    this.sort.sort({id: '', start: 'asc'} as MatSortable);
    this.sort.sort({id: 'lastUpdate', start: 'asc'} as MatSortable);
    const configs = this.desktopInfos?.configs?.sort((a: DesktopConfig, b: DesktopConfig) => {
      return Number(b.updatedAt ?? 0) - Number(a.updatedAt ?? 0);
    }) || [];
    this.hasDesktopApiContent = configs.length > 0;
    this.dataSource = new MatTableDataSource<DesktopConfig>(configs);
    this.dataSource.sort = this.sort;
    this.isLoading = false;
  }

  public openInfoDialog(selectedConfig: DesktopConfig){
    this.dialog.open(HardwareInfoDialogComponent, {
      data: selectedConfig,
      height: '600px',
      width: '1000px'
    });
  }

  public getBytes(bytes: number): string{
    return humanReadableBytes(bytes);
  }

  public openConfirmDesactivationDialog(selectedConfig: DesktopConfig){
    const dialogRef = this.dialog.open(DesactivationConfigDialogComponent, {
      data: selectedConfig,
      height: '400px',
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(async configId => {
      if(configId){
        const groupId = this.desktopInfos?.groupId;
        if (!groupId) {
          return;
        }

        const resp = await this.desktopService.deleteConfigInGroup(groupId, configId);
        if(resp?.status?.status === 200){
          this.displayWarningMessage('La config a bien été supprimée du groupe', MessageTypeEnum.SUCCESS);
          const gcResp = await this.desktopService.getGroupConfig(groupId);
          this.desktopInfos = gcResp;
          this.initialize();
        }else{
          this.displayWarningMessage('Erreur lors de la suppression de la config', MessageTypeEnum.ERROR);
        }
      }
    });
  }

  private displayWarningMessage(message: string, messageType: MessageTypeEnum){
    this.snackBar.open(message, '', {
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: [messageType]
    });
  }

  public formatUpdateDate(date: number): string{
    const updateDate: Date = new Date(date)
    const updateDateDay = String(updateDate.getDate()).padStart(2, '0');
    const updateDateMonth = String(updateDate.getMonth() + 1).padStart(2, '0');
    const updateDateYear = updateDate.getFullYear();
    return `${updateDateDay}/${updateDateMonth}/${updateDateYear}`;
  }

  public getUrl(url: string): string{
    return url.replace(/^(https?:\/\/)?(www\.)?/, '');
  }

}
